import { Component, HostListener, Inject, Input } from '@angular/core';
import { Storefront } from '@queries/generated';
import { WINDOW } from 'src/app/app.module';

@Component({
  selector: 'vnm-storefront-brand',
  templateUrl: './storefront-brand.component.html',
  styleUrls: ['./storefront-brand.component.scss']
})
export class StorefrontBrandComponent {
  @HostListener('click', ['$event']) visitStorefront(_: Event) {
    this.window.open(this.storefront.url);
  }

  @Input() storefront: Storefront;

  constructor(@Inject(WINDOW) private window: Window) {}
}
